// this must be defined statically because at app start we don't have values from launchdarkly yet.

// setting to 0 for now since we aren't really using this (crashlytics / amp work better) and it costs money
export const SESSION_SAMPLE_RATE = 0;
